module.exports = __webpack_public_path__ + "media/how_fastweb_works/cbs_logo_02-0f524c7c.png";